import { ButtonProps } from "@/types/buttons";
import { classNames } from "@/utils/general";

const MediumOutlineButton = ({ click, children, width = 'auto' }: ButtonProps) => {
    const classes = 'py-2.5 px-6 ease-in duration-100 border text-sm rounded-md bg-white hover:border-gray-400 hover:bg-gray-100 focus:ring-2 focus:ring-gray-200';
    return (
        <button onClick={click} className={classNames(classes, width === 'full' ? 'w-full' : '')}>
            {children}
        </button>
    );
}

MediumOutlineButton.defaultProps = {
    width: 'auto',
    click: () => {}
}

export default MediumOutlineButton;